import React from 'react'
import type { TableRowProps } from '@paintscout/ui'
import { TableRow } from '@paintscout/ui'

export interface ItemTableRowProps extends TableRowProps {}

export default function ItemTableRow(props: ItemTableRowProps) {
  return <TableRow {...props} component="tr" />
}
